/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LayersIcon = ({ width = 24, height = 24, hidden = false, title = 'Layers' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m28.288 19.938-9.839 6.827a.788.788 0 0 1-.898 0l-9.839-6.827L1.858 24a.25.25 0 0 0 0 .41l15.85 10.999a.512.512 0 0 0 .584 0l15.85-10.998a.25.25 0 0 0 0-.41Z"
    />
    <path
      d="M17.699 22.988 1.858 11.996a.25.25 0 0 1 0-.41L17.698.594a.529.529 0 0 1 .603 0l15.841 10.992a.25.25 0 0 1 0 .41l-15.84 10.992a.529.529 0 0 1-.603 0Z"
    />
  </svg>`;
};
